import React, { Component } from 'react'
// CSS
import './App.css'
import Admin from './components/Admin'
import Card from './components/Card'
import Header from './components/Header'
// Firebase
import base from './base'

class App extends Component {
  state = {
    pseudo: this.props.match.params.pseudo,
    recettes: {},
    user: []
    }

  componentDidMount () {
    //reference ds firebase
    base.syncState(`/user/${this.state.pseudo}`, {
      context: this,
      state: 'user',
    then: function() {
      if(Object.keys(this.state.user).length !== 0)
      {
        this.ref = base.syncState(`/listeRecettes`,{
          context: this,
          state: 'recettes',
          queries: {
            orderByChild: "id",
            equalTo: this.state.user.id,
          }
        })
      }
    }
  });
  }

  componentWillUnmount () {
    //fermer la reference ds firebase
    //la connexion est terminée entre notre state et firebase
    base.removeBinding(this.ref)
  }

  ajouterRecette = recette => {
    const recettes = { ...this.state.recettes }
    recettes[`recette-${Date.now()}`] = recette
    this.setState({ recettes })
  }

  majRecette = (key, newRecette) => {
    const recettes = { ...this.state.recettes }
    recettes[key] = newRecette
    this.setState({ recettes })
  }

  supprimerRecette = key => {
    const recettes = { ...this.state.recettes }
    recettes[key] = null
    this.setState({ recettes })
  }

  render () {

    const cards = Object
    .keys(this.state.recettes)
  .map(key => <Card key={key} details={this.state.recettes[key]}/>)
    return (
      <div className='box'>
        <Header pseudo={this.state.pseudo}></Header>
        <div className='cards'>
            { cards }
        </div>
        <Admin 
        pseudo={this.state.pseudo}
        recettes={this.state.recettes}
        admin={this.state.user.admin}
        confirm={this.state.user.confirm}
        id={this.state.user.id}
        chef={this.state.user.chef}
        //first param pour le props dans Admin, second va chercher la fonction créée
        ajouterRecette={this.ajouterRecette}
        majRecette={this.majRecette}
        supprimerRecette={this.supprimerRecette}/>
      </div>
    )
  }
}

export default App
